import type {
  KnowledgeArticleDetailDto,
  KnowledgeArticleListDto,
  KnowledgeArticleListDtoListResponse,
  SelectDto,
} from '../generated/model';
import {
  createMainCategory,
  createSelectedMainCategory,
  createSelectedSubCategory,
} from './ticket';

export const createKnowledgeArticleListResult = (
  overrides: Partial<KnowledgeArticleListDtoListResponse> = {},
): KnowledgeArticleListDtoListResponse => ({
  items: [
    createKnowledgeListArticle(),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100101',
      id: '1',
      title: 'Hoe kan ik mijn meterstanden doorgeven?',
      modifiedOn: '2022-10-25T00:00:00Z',
    }),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100102',
      id: '2',
      title: 'Wat te doen bij een stroomstoring?',
    }),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100103',
      id: '3',
      title: 'Hoe maak je een ticket aan?',
      mainCategory: {
        label: 'Non conformiteit',
        id: 'c24b70d0-69ba-ec11-983f-000d3a4c82a2',
      },
      subCategory: {
        id: 'e6f7e4a2-7dc6-ea11-a812-000d3a21145g',
        label: 'GV Non conformiteit',
      },
    }),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100104',
      id: '4',
      title: 'Handleiding voor Partners in Energie',
      modifiedOn: '2024-11-21T00:00:00Z',
      mainCategory: {
        label: 'Allocatie',
        id: '311fd09c-7dc6-ea11-a812-000d3a21145f',
      },
      subCategory: {
        id: 'f6f7e4a2-7dc6-ea11-a812-000d3a21145f',
        label: 'Meetdata',
      },
    }),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100105',
      id: '5',
      title: 'Hoeveel verbruik heeft een aansluiting?',
      modifiedOn: '2025-05-03T00:00:00Z',
      mainCategory: {
        label: 'Allocatie',
        id: '311fd09c-7dc6-ea11-a812-000d3a21145f',
      },
      subCategory: {
        id: 'f6f7e4a2-7dc6-ea11-a812-000d3a21145f',
        label: 'Meetdata',
      },
    }),
    createKnowledgeListArticle({
      articlePublicNumber: 'KA-0100106',
      id: '6',
      title: 'Wat is het verschil tussen grootvebruik en kleinverbruik?',
      mainCategory: {
        label: 'Kleinverbruik',
        id: 'c24b70d0-69ba-ec11-983f-000d3a4c1234',
      },
      subCategory: {
        id: 'e6f7e4a2-7dc6-ea11-a812-000d3a214321',
        label: 'Kleinverbruik sub',
      },
    }),
  ],
  totalCount: 7,
  ...overrides,
});

export const createKnowledgeListArticle = (
  overrides: Partial<KnowledgeArticleListDto> = {},
): KnowledgeArticleListDto => ({
  articlePublicNumber: 'KA-0100100',
  createdOn: '2021-09-01T00:00:00Z',
  content: 'lorem ipsum dolor sit amet',
  id: '0',
  mainCategory: createSelectedMainCategory(),
  modifiedOn: '2021-10-01T00:00:00Z',
  subCategory: createSelectedSubCategory(),
  title:
    'Onze klant geeft een afwijkende meterstand door, heeft er een meterwissel plaatsgevonden?',
  ...overrides,
});

export const createKnowledgeArticleDetail = (
  overrides: Partial<KnowledgeArticleDetailDto> = {},
): KnowledgeArticleDetailDto => ({
  ...createKnowledgeListArticle(),
  attachments: [
    {
      bytes: 123,
      fileName: 'Example document',
      id: '0',
    },
    {
      bytes: 123,
      fileName: 'Name file',
      id: '1',
    },
  ],
  content: `Dolore laborum officia sunt esse laboris consectetur consectetur do. Est amet enim aute occaecat. Aute excepteur commodo est laboris nostrud irure sunt ea nisi ut. Nostrud proident non eiusmod laborum magna minim occaecat consectetur minim. Sit exercitation excepteur et cupidatat. Ad deserunt ea non aliquip minim. Officia irure id irure non nisi proident veniam officia sunt et. Eiusmod sunt labore cillum exercitation laborum esse sit laboris mollit sit anim nisi sit velit quis. Id voluptate veniam ut consequat dolore duis incididunt non aute duis sunt.
    <section>
        <h1>Section 1</h1>
        <p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>.
            Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. <u>Underlined text example</u>.</p>
        <p><em>Duis vulputate commodo lectus</em>, ac blandit elit tincidunt id. Sed rhoncus, tortor sed eleifend tristique, tortor mauris molestie elit, et lacinia ipsum quam nec dui.</p>
        <div>This is a <span style="color: blue;">span</span> inside a div. <br> Here's a line break.</div>
        <figure>
            <img src="https://via.placeholder.com/150" alt="Placeholder Image">
            <figcaption>Example of a placeholder image.</figcaption>
        </figure>
    </section>
    <section>
        <h2>Section 2</h2>
        <p>Quisque at <a href="#">dolor gravida</a> tortor varius dictum. Proin ut ligula vel nunc egestas porttitor. Donec dictum metus in sapien.</p>
        <img src="/msdyn_knowledgearticleimages(123)" />
        <blockquote>"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante."</blockquote>
        <ul>
            <li>Unordered list item 1</li>
            <li>Unordered list item 2</li>
            <li>Unordered list item 3</li>
        </ul>
        <ol>
            <li>Ordered list item 1</li>
            <li>Ordered list item 2</li>
            <li>Ordered list item 3</li>
        </ol>
    </section>
    <section>
        <h3>Section 3</h3>
        <p>Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. <strong>Strong text example</strong>.</p>
    </section>`,
  ...overrides,
});

export const createKnowledgeArticleCategory = (
  overrides: Partial<SelectDto> = {},
): SelectDto => {
  const category = createMainCategory();
  return { id: category.id, label: category.name, ...overrides };
};
